import {round, isInteger} from 'lodash';

export class NumberHelper {
    static fixDecimalSignPosition(value, sign = ".", precision = 2) {
        precision = parseInt(precision);

        if (value.indexOf(sign) >= 0 && (value.length - value.indexOf(sign)) > (precision + 1)) {
            value = value.replace(/\./g, "");
            let thousand = value.slice(0, -(precision));
            let decimals = value.slice(-(precision));

            return thousand + sign + decimals;
        }

        const patt = new RegExp("\\" + sign + "$");
        if (value && value.indexOf(sign) < 0 || patt.test(value)) {
            if (patt.test(value)) {
                value = value.substring(0, value.length - 1);
            }
            let thousand = value.slice(0, -precision);
            let decimals = value.slice(-(precision));

            if (!thousand) {
                thousand = value;
                decimals = NumberHelper.createDefaultDecimals(precision);
            }

            return thousand + sign + decimals;
        }

        return value;
    }

    static addMissingDecimalSign(value, sign = ".", precision = 2) {
        precision = parseInt(precision);
        if (value) {
            let thousandEnd = -(value.length - value.indexOf(sign));
            let decimalEnd = thousandEnd + 1;
            if (value.indexOf(sign) < 0) {
                thousandEnd = -precision;
                decimalEnd = thousandEnd;
            }

            let thousand = value.slice(0, thousandEnd);
            let decimals = value.slice(decimalEnd);

            if (decimals.length < precision) {
                decimals += NumberHelper.createDefaultDecimals(precision - decimals.length);
            }

            if (!thousand || value.length === (precision + 1)) {
                thousand = value;
                decimals = NumberHelper.createDefaultDecimals(precision);
            }

            return thousand + sign + decimals;
        }

        return value;
    }

    static createDefaultDecimals(precision) {
        const decimals = [];
        for (let i = 0; i < precision; i++) {
            decimals.push("0");
        }

        return decimals.join("");
    }

    static round(number, decimals = 2) {
        if (!isInteger(decimals) || decimals < 0) {
            throw new Error('Decimal number should be an positive int');
        }

        return round(number, decimals);
    }
}
